module.exports = __webpack_public_path__ + "static/img/avatar.8f4ca14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/avatar.png
// module id = 2Vni
// module chunks = 1